__turbopack_context__.v({
  "searchError": "SearchError-module-scss-module__NykNSa__searchError",
  "searchErrorText": "SearchError-module-scss-module__NykNSa__searchErrorText",
  "searchErrorTitle": "SearchError-module-scss-module__NykNSa__searchErrorTitle",
});
